import { ComponentsOverrides, Theme } from '@mui/material';
import { Property } from 'csstype';

export const MuiInputBase: { styleOverrides: ComponentsOverrides<Theme>['MuiInputBase'] } = {
    styleOverrides: {
        root: ({ theme }) => ({
            backgroundColor: theme.palette.common.white,
            '&.Mui-disabled': {
                backgroundColor: '#FBFBFB',
            },
        }),
    },
};

export const MuiInputLabel: { styleOverrides: ComponentsOverrides<Theme>['MuiInputLabel'] } = {
    styleOverrides: {
        root: ({ theme }) => ({
            color: theme.palette.grey['700'],
        }),
        outlined: {
            marginLeft: 2,
        },
        shrink: {
            transform: 'translate(14px, -9px) scale(0.8)',
        },
    },
};

export const MuiOutlinedInput: { styleOverrides: ComponentsOverrides<Theme>['MuiOutlinedInput'] } = {
    styleOverrides: {
        input: ({ ownerState }) => ({
            padding: '17px 16px',
            height: 22,
            ...(ownerState['startAdornment'] && {
                paddingLeft: 8,
            }),
            ...(ownerState['endAdornment'] && {
                paddingRight: 8,
            }),
            textAlign: ownerState['textAlign'] ?? 'left',
        }),
        notchedOutline: {
            borderWidth: 1.5,
            '& > legend': {
                fontSize: '0.8em', // FIXME somehow the legends width is not like in the admin portal
            },
        },
        adornedStart: ({ theme }) => ({
            paddingLeft: theme.spacing(2),
        }),
        adornedEnd: ({ theme }) => ({
            paddingRight: theme.spacing(2),
        }),
        multiline: ({ theme }) => ({
            padding: theme.spacing(2),
        }),
        inputMultiline: ({ theme }) => ({
            padding: theme.spacing(0, 2, 0, 0),
        }),
    },
};

declare module '@mui/material/OutlinedInput' {
    interface OutlinedInputProps {
        textAlign?: Property.TextAlign;
    }
}
